import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { KEYS } from '../../constants/keys.js';
import { spacing1x } from '../../styles/spacing.js';
import { mergeProps } from '../../utils/react.js';
import { useButtonMenuContext, FOCUS_ELEMENTS } from '../ButtonMenuContainer/ButtonMenuContainer.js';
import { Menu } from '../Menu/Menu.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children"];
var MIN_WIDTH = 100;
var ButtonMenuMenu = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _context$buttonRef, _context$buttonRef$cu;

  var context = useButtonMenuContext();

  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var childrenLength = React.Children.toArray(children).length;

  var handleMenuKeyDown = function handleMenuKeyDown(e) {
    switch (e.key) {
      case KEYS.TAB:
        {
          context.setFocusItem(void 0);
          context.setShowingState(false);
          break;
        }

      case KEYS.ESCAPE:
        {
          context.setFocusItem(FOCUS_ELEMENTS.BUTTON);
          context.setShowingState(false);
          break;
        }
    }
  };

  return /*#__PURE__*/jsx(Menu, _objectSpread(_objectSpread({}, mergeProps(_objectSpread(_objectSpread({}, rest), {}, {
    ref: ref
  }), {
    "aria-labelledby": context.id,
    borderRadius: 1,
    elevation: 2,
    onKeyDown: handleMenuKeyDown,
    ref: context.menuRef,
    style: {
      marginTop: spacing1x,
      maxHeight: "inherit",
      minWidth: Math.max(((_context$buttonRef = context.buttonRef) === null || _context$buttonRef === void 0 ? void 0 : (_context$buttonRef$cu = _context$buttonRef.current) === null || _context$buttonRef$cu === void 0 ? void 0 : _context$buttonRef$cu.offsetWidth) || 0, MIN_WIDTH),
      overflowY: "auto",
      textAlign: "left",
      whiteSpace: "nowrap"
    }
  })), {}, {
    children: React.Children.map(children, function (child, index) {
      if (! /*#__PURE__*/React.isValidElement(child)) return child;
      var item = child;
      return /*#__PURE__*/React.cloneElement(item, mergeProps(_objectSpread(_objectSpread({}, item.props), {}, {
        ref: item.ref
      }), {
        ref: childrenLength - 1 === index ? context.lastItemRef : void 0
      }));
    })
  }));
});
ButtonMenuMenu.displayName = "ButtonMenuMenu";

export { ButtonMenuMenu };
